module.exports = {
  theme: {
    colors: {
      primary: '#6563ff',
      black: '#1a1a1a',
      red: '#ff2a2a',
      success: '#00c853',
      danger: '#ff2a2a',
    },
    fonts: {
      sans: [
        'Source Sans Pro',
        'Arial',
        'sans-serif'
      ],
      title: [
        'Fira Sans Condensed',
        'Arial',
        'sans-serif'
      ]
    },
    typography: {
      body: {
        font: 'sans',
        leading: 'md',
        color: 'black',
        weight: 'normal',
        size: 'md'
      },
      title: {
        font: 'title',
        leading: 'sm',
        weight: 'semibold'
      },
      paragraph: {
        leading: 'md',
        weight: 'normal'
      },
      link: {
        color: 'primary'
      }
    }
  }
}
